/**
 * Shared Amazon-storefront locale toggle grid.
 *
 * Same UI used by both the Assign dialog and the Edit-shave dialog.
 * Each locale tile is a button; clicking flips its membership in the
 * caller's `selected` array. We use the locale's `code` (US, GB, JP…)
 * in the data-testid so playwright can target specific tiles.
 */
export default function LocalePickerGrid({
  catalog, selected, onToggle, testIdPrefix,
}) {
  return (
    <div
      className="grid grid-cols-3 gap-1.5 max-h-64 overflow-y-auto p-2 border border-slate-200 rounded-md bg-slate-50/50"
      data-testid={`${testIdPrefix}-locales`}
    >
      {catalog.map((loc) => {
        const on = selected.includes(loc.domain);
        return (
          <button
            key={loc.domain}
            type="button"
            onClick={() => onToggle(loc.domain)}
            className={`flex items-center gap-1.5 px-2 py-1.5 rounded text-left text-xs transition-colors border ${
              on
                ? "bg-[#002FA7] text-white border-[#002FA7]"
                : "bg-white text-slate-700 border-slate-200 hover:bg-slate-100"
            }`}
            data-testid={`${testIdPrefix}-locale-${loc.code}`}
          >
            <span>{loc.flag}</span>
            <span className="font-mono text-[10px]">{loc.domain}</span>
          </button>
        );
      })}
    </div>
  );
}
